import { c as _c } from "react/compiler-runtime";
import { COUNTRIES } from '@onefootprint/core';
import { Divider, Form } from '@onefootprint/ui';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import Section from '@/playbook-builder/components/section';
import type { FormIdentityData } from '../../collect-data-node/components/person/person.types';
const ResidencyForm = () => {
  const $ = _c(53);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "collectData.person.residency"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("playbook-builder", t0);
  const {
    control,
    setValue
  } = useFormContext();
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["ssn"];
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== control) {
    t2 = {
      control,
      name: t1
    };
    $[2] = control;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const [ssn] = useWatch(t2);
  let t3;
  if ($[4] !== setValue) {
    t3 = nextValue => {
      if (nextValue.target.checked) {
        setValue("ssn.kind", "ssn9");
      }
    };
    $[4] = setValue;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const onChangeSsnCollect = t3;
  let t4;
  if ($[6] !== setValue) {
    t4 = nextValue_0 => {
      if (nextValue_0.target.value === "us_tax_id") {
        setValue("ssn.optional", false);
      }
    };
    $[6] = setValue;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const onChangeSsnKind = t4;
  let t5;
  if ($[8] !== t) {
    t5 = t(_temp);
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t) {
    t6 = t(_temp2);
    $[10] = t;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t6) {
    t7 = <Form.MultiSelect name="residentialAddressCountries" label={t6} options={COUNTRIES} />;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t) {
    t8 = t(_temp3);
    $[14] = t;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t8) {
    t9 = <div className="mb-4 text-label-2 text-primary">{t8}</div>;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t) {
    t10 = t(_temp4);
    $[18] = t;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== onChangeSsnCollect || $[21] !== t10) {
    t11 = <Form.Checkbox name="ssn.collect" label={t10} onChange={onChangeSsnCollect} />;
    $[20] = onChangeSsnCollect;
    $[21] = t10;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== onChangeSsnKind || $[24] !== ssn.collect || $[25] !== ssn.kind || $[26] !== t) {
    t12 = ssn.collect ? <><Divider className="my-3" variant="secondary" /><div className="flex flex-col gap-1"><Form.RadioGroup name="ssn.kind" options={[{
          label: t(_temp5),
          hint: ssn.kind === "ssn9" ? t(_temp6) : undefined,
          value: "ssn9"
        }, {
          label: t(_temp7),
          value: "ssn4"
        }, {
          label: t(_temp8),
          hint: ssn.kind === "us_tax_id" ? t(_temp9) : undefined,
          value: "us_tax_id"
        }]} onChange={onChangeSsnKind} /></div><Divider className="my-3" variant="secondary" /><Form.Checkbox name="ssn.optional" label={t(_temp10)} disabled={ssn.kind === "us_tax_id"} /></> : null;
    $[23] = onChangeSsnKind;
    $[24] = ssn.collect;
    $[25] = ssn.kind;
    $[26] = t;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== t11 || $[29] !== t12 || $[30] !== t9) {
    t13 = <div>{t9}{t11}{t12}</div>;
    $[28] = t11;
    $[29] = t12;
    $[30] = t9;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== t) {
    t14 = t(_temp11);
    $[32] = t;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] !== t14) {
    t15 = <div className="mb-4 text-label-2 text-primary">{t14}</div>;
    $[34] = t14;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] !== t) {
    t16 = t(_temp12);
    $[36] = t;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== t) {
    t17 = t(_temp13);
    $[38] = t;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  let t18;
  if ($[40] !== t16 || $[41] !== t17) {
    t18 = <Form.Checkbox name="usLegalStatus" label={t16} hint={t17} />;
    $[40] = t16;
    $[41] = t17;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  let t19;
  if ($[43] !== t15 || $[44] !== t18) {
    t19 = <div>{t15}{t18}</div>;
    $[43] = t15;
    $[44] = t18;
    $[45] = t19;
  } else {
    t19 = $[45];
  }
  let t20;
  if ($[46] !== t13 || $[47] !== t19 || $[48] !== t7) {
    t20 = <div className="flex flex-col gap-8">{t7}{t13}{t19}</div>;
    $[46] = t13;
    $[47] = t19;
    $[48] = t7;
    $[49] = t20;
  } else {
    t20 = $[49];
  }
  let t21;
  if ($[50] !== t20 || $[51] !== t5) {
    t21 = <Section title={t5}>{t20}</Section>;
    $[50] = t20;
    $[51] = t5;
    $[52] = t21;
  } else {
    t21 = $[52];
  }
  return t21;
};
export default ResidencyForm;
function _temp($) {
  return $.title;
}
function _temp2($_0) {
  return $_0.countries.title;
}
function _temp3($_1) {
  return $_1.countries.us.title;
}
function _temp4($_2) {
  return $_2.countries.us.taxId.label;
}
function _temp5($_3) {
  return $_3.countries.us.taxId.ssn9;
}
function _temp6($_4) {
  return $_4.countries.us.taxId.ssn9Hint;
}
function _temp7($_5) {
  return $_5.countries.us.taxId.ssn4;
}
function _temp8($_6) {
  return $_6.countries.us.taxId.ssnOrItin;
}
function _temp9($_7) {
  return $_7.countries.us.taxId.ssnOrItinHint;
}
function _temp10($_8) {
  return $_8.countries.us.taxId.optional;
}
function _temp11($_9) {
  return $_9.countries.us.legalStatus.title;
}
function _temp12($_10) {
  return $_10.countries.us.legalStatus.label;
}
function _temp13($_11) {
  return $_11.countries.us.legalStatus.hint;
}